import React from 'react'

export const FacebookIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="9"
    height="17"
    viewBox="0 0 9 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 9.775H8.14286L9 6.375H6V4.675C6 3.7995 6 2.975 7.71429 2.975H9V0.119C8.72057 0.0824501 7.66543 0 6.55114 0C4.224 0 2.57143 1.40845 2.57143 3.995V6.375H0V9.775H2.57143V17H6V9.775Z"
      fill="currentColor"
    />
  </svg>
)
